import { useLanguage } from "../../../contexts";

const LANGS = ["es", "en", "pt"];

export function LanguageSwitcher() {
  const { language, changeLanguage } = useLanguage();

  return (
    <span className="login-footer__lang">
      {LANGS.map((lang) => (
        <button
          key={lang}
          type="button"
          className={language === lang ? "active" : ""}
          onClick={() => changeLanguage(lang)}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </span>
  );
}
